import React from "react"
import { useParams } from "react-router-dom";
import { Box, CardBody, CardHeader, Divider, VStack } from "@chakra-ui/react";
import { SettingItem } from "../../organisms/SettingItem";
import { useFetchKuchikomyuSettingByRestaurantId } from "../../../hooks/kuchikomyu/useFetchKuchikomyuSettingByRestaurantId";
import { DarkShadowCard } from "../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../molecules/card/CardHeading";
import { SettingsIcon } from "@chakra-ui/icons";
import { CircularLoading } from "../../molecules/loading/CircularLoading";
import { RestaurantSettingCardFooter } from "../../organisms/restaurant/RestaurantSettingCardFooter";


export const KuchikomyuSetting = () => {
  const { restaurantId } = useParams();
  const {kuchikomyuSetting, isLoading} = useFetchKuchikomyuSettingByRestaurantId(restaurantId);
  if (isLoading) return <CircularLoading />;
  const path = kuchikomyuSetting ? `${kuchikomyuSetting.id}/edit` : `register`;
  const settingItems = [
    {label: 'ブランチスコア', content: kuchikomyuSetting?.branch_score ?? '未登録'},
    {label: 'URL①', content: kuchikomyuSetting?.g_url ?? '未登録'},
    {label: '英語版URL①', content: kuchikomyuSetting?.en_url ?? '未登録'},
    {label: 'URL②', content: kuchikomyuSetting?.default_url ?? '未登録'},
    {label: '英語版②', content: kuchikomyuSetting?.default_en_url ?? '未登録'},
  ];
  return (
    <DarkShadowCard w='100%'>
      <CardHeader pb={0}>
        <CardHeading icon={<SettingsIcon />} heading='口コミュ設定'/>
      </CardHeader>
      <CardBody>
        <VStack align='start' fontSize='sm' fontWeight='bold' spacing={4} w='100%'>
          <Divider my={0} />
          {settingItems.map((detail) => (
            <React.Fragment key={detail.label}>
              <Box w='100%'>
                <SettingItem label={detail.label} content={detail.content}/>
              </Box>
              <Divider my={0} />
            </React.Fragment>
          ))}
        </VStack>
      </CardBody>
      <RestaurantSettingCardFooter path={path} />
    </DarkShadowCard>
  );
};